import { useEffect, useMemo, useState } from 'react';
import resolveCachedImageURL from 'src/lib/sync-box/image-cache/utils/resolveCachedImageURL';
function useCachedImgURL(src) {
    const srcArr = useMemo(() => [].concat(src ?? []), [src]);
    const [resolvedSrc, setResolvedSrc] = useState(() => ({
        loading: true,
        data: Array.isArray(src) ? new Array(srcArr.length).fill(undefined) : undefined,
        error: null,
    }));
    useEffect(() => {
        setResolvedSrc(prevState => ({
            ...prevState,
            loading: true,
            error: null,
        }));
        Promise.allSettled(srcArr
            .map(item => resolveCachedImageURL(item ?? '')))
            .then(results => {
            const resolvedData = results.map(result => result.status === 'fulfilled' ? result.value : undefined);
            const data = Array.isArray(src) ? resolvedData : resolvedData[0];
            setResolvedSrc({
                loading: false,
                data,
                error: null,
            });
        }).catch((error) => {
            setResolvedSrc({
                loading: false,
                data: srcArr,
                error,
            });
        });
    }, [src]);
    return resolvedSrc;
}
export default useCachedImgURL;
